import { render, staticRenderFns } from "./XCountDownLabel.vue?vue&type=template&id=32d491ed&scoped=true"
import script from "./XCountDownLabel.vue?vue&type=script&lang=js"
export * from "./XCountDownLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d491ed",
  null
  
)

export default component.exports